<div #ttChartContainer class="task-tracker-chart-container">
    <highcharts-chart *ngIf="chartOptions && !hasNoChartData" [Highcharts]="Highcharts" [options]="chartOptions"></highcharts-chart>

    <div *ngIf="hasNoChartData" class="tt-no-data-chart-container">
        {{'STRINGS.NO_CHART_DATA_TO_DISPLAY' | translate | titlecase }}.
    </div>
</div>
